import React from 'react';
import PropTypes from 'prop-types';
import { getAddressLabel } from '@quiqupltd/qu-react-sdk/lib/components/qu-address/utils';
import { PICKUP, DROPOFF, RETURN } from '../../../utils/constants';
import { locationPropTypes } from '../../../utils/prop-types';
import { Container, WaypointText, Icon } from './address.styles';
import { Label } from '../styles';

export const ICON = {
  pickup: {
    icon: 'location',
    width: 17,
    height: 17,
  },
  dropoff: {
    icon: 'building-pin',
    width: 16,
    height: 13,
  },
  return: {
    icon: 'location',
    width: 17,
    height: 17,
  },
};

const Address = ({ location, type }) => {
  return (
    <Container>
      <Label>Address</Label>
      <Icon {...ICON[type]} type={type} />
      <WaypointText>{getAddressLabel(location)}</WaypointText>
    </Container>
  );
};

Address.propTypes = {
  location: locationPropTypes.isRequired,
  type: PropTypes.oneOf([PICKUP, DROPOFF, RETURN]).isRequired,
};

export default Address;



// WEBPACK FOOTER //
// ./src/app/order-card/address/address.js